
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';

import UTILService from '@/services/utils.service';

import CarService from '@/services/car.service';

@Component({})
export default class LookCarPhone extends Vue {
  @lazyInject(UTILService)
  private utilService!: UTILService;
  @lazyInject(CarService)
  carService!: CarService;

  visible = false;

  phone: any = null;

  hideModal() {
    this.visible = false;
    this.phone = null;
  }

  async init(type: string, val: any, poi?: string) {
    this.visible = true;
    const data = {
      encrypt_phone: val,
      operate_type: type,
      poi,
    };
    try {
      const res = await this.carService.postPhoneDecrypt(data);
      if (res) {
        this.visible = true;
        this.phone = res;
      }
    } catch (error) {
      this.$message.error('解密失败');
    }
  }
}
